if (!customElements.get('modal-window')) {
  customElements.define(
    'modal-window',
    class ModalWindow extends HTMLElement {
      constructor() {
        super();

        this.trigger = this.querySelector('[data-modal-trigger]');
        this.close = this.querySelectorAll('[data-modal-close]');
        this.modalId = this.getAttribute('data-modal-id');
        this.bodyClass = `modal-${this.modalId}-is-open`;

        if (this.trigger) {
          this.trigger.addEventListener('click', this.openModal.bind(this));
        }

        this.close.forEach((button) => {
          button.addEventListener('click', this.closeModal.bind(this));
        });

        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeModal();
          }
        });

        window.addEventListener('resize', this.closeModal.bind(this));

        if (this.modalId) {
          ModalWindow.registerModal(this.modalId, this);
        }
      }

      static modals = new Map();

      static registerModal(id, modal) {
        ModalWindow.modals.set(id, modal);
      }

      static openModalById(id) {
        const modal = ModalWindow.modals.get(id);
        if (modal) {
          modal.openModal();
        }
      }

      findElements() {
        this.target = this.target || this.querySelector('[data-modal-target]');
        this.body = this.body || document.body;
      }

      openModal() {
        this.findElements();
        this.target?.classList.remove('hidden');
        this.body.classList.add(this.bodyClass);
      }

      closeModal() {
        this.findElements();
        this.target?.classList.add('hidden');
        this.body.classList.remove(this.bodyClass);
      }
    }
  );

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-open]');
    if (trigger) {
      e.preventDefault();
      const modalId = trigger.getAttribute('data-modal-open');
      const ModalWindow = customElements.get('modal-window');
      if (ModalWindow && ModalWindow.openModalById) {
        ModalWindow.openModalById(modalId);
      }
    }
  });
} else {
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-open]');
    if (trigger) {
      e.preventDefault();
      const modalId = trigger.getAttribute('data-modal-open');
      const ModalWindow = customElements.get('modal-window');
      if (ModalWindow && ModalWindow.openModalById) {
        ModalWindow.openModalById(modalId);
      }
    }
  });
}
